// extracted by mini-css-extract-plugin
export var copyableField = "_ox-4";
export var customerBadge = "_ox-0";
export var customerInfoTitle = "_ox-2";
export var details = "_ox-1";
export var dropdownContainer = "_ox-5";
export var dropdownImage = "_ox-6";
export var editAssigneeForm = "_ox-a";
export var editButton = "_ox-3";
export var email = "_ox-7";
export var hidden = "_ox-d";
export var input = "_ox-8";
export var saveButton = "_ox-b";
export var shopifyIcon = "_ox-c";
export var suggestionBadge = "_ox-e";
export var suggestionText = "_ox-f";
export var username = "_ox-9";